import { render } from "./MailingList.vue?vue&type=template&id=f697e0b8&scoped=true"
import script from "./MailingList.vue?vue&type=script&lang=js"
export * from "./MailingList.vue?vue&type=script&lang=js"

import "./MailingList.vue?vue&type=style&index=0&id=f697e0b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f697e0b8"]])

export default __exports__